import { Box, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

export interface PillProps {
  children: React.ReactNode;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export function Pill(props: PillProps) {
  const { children, disabled, sx } = props;

  return (
    <Box
      sx={mergeSxProps(
        (theme: Theme) => ({
          display: "inline-flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          paddingY: 2,
          // outside of design system, one-off to make it look less tight
          paddingX: "7px",
          lineHeight: 1,
          backgroundColor: theme.palette.background.default,
          border: `${theme.borderWidth?.regular} solid ${theme.palette.base?.base}`,
          borderRadius: theme.borderRadius?.xLarge,
          fontSize: theme.typography.body2.fontSize,
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette.base?.strong,
          textAlign: "center",
          opacity: disabled ? theme.opacity?.disabled : undefined,
        }),
        sx
      )}
    >
      {children}
    </Box>
  );
}
